import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/features/auth/contexts/AuthContext";
import { Loading } from "@/components/ui/loader";
import { userHasPermission } from "@/lib/user-permissions";

interface PermissionRouteProps {
	children: React.ReactNode;
	/** Required permission (user needs at least one if array). Dot format e.g. "sales.read" */
	permission: string | string[];
}

export const PermissionRoute: React.FC<PermissionRouteProps> = ({ children, permission }) => {
	const { user, isAuthenticated, isLoading } = useAuth();
	const location = useLocation();

	if (isLoading) return <Loading />;

	if (!isAuthenticated) {
		return <Navigate to="/login" state={{ from: location }} replace />;
	}

	if (!userHasPermission(user, permission)) {
		return <Navigate to="/profile" state={{ from: location, restricted: true }} replace />;
	}

	return <>{children}</>;
};
